import $ from 'jquery';
import 'slick';
import 'magnific-popup/dist/jquery.magnific-popup';
import { 
    slickCommonOptions 
} from '../../scripts/config';

/**
 * GalleryV2 widget configs
 */
const galleryV2Semantics = {
    'mainWrapClass': 'gallery-v2',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'commonPluginOptionsAttribute': 'data-common-plugin-options',
    'controlPrevClass': 'gallery-v2__prev',
    'controlNextClass': 'gallery-v2__next',
    'sliderElementClass': 'gallery-v2__track',
    'overlayElementClass': 'gallery-v2__overlay',
    'slideElement': 'gallery-v2__track-element',
    'popupMainClass': 'gallery-v2__popup',
};

/**
 * GalleryV2 initializer
 */
$(function() {

    if ($(`.${galleryV2Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    window.widgets.galleryV2 = new GalleryV2();

    /**
     * Checking other instances
     */
    $(`.${galleryV2Semantics.mainWrapClass}`).each((index, el) => {
        let isInitialized = 
            ($(el).attr(`${galleryV2Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            window.widgets.galleryV2.registerInstance($(el));
            window.widgets.galleryV2.registerListeners($(el));
        }
    });

});

class GalleryV2
{
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId = 
            el.attr(`${galleryV2Semantics.instanceIdAttribute}`) || false;
        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        let commonPluginOptions = 
            el.data(
                `${galleryV2Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};


        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: true,
                variableWidth: true,
                // variableWidth: false,
                mobileFirst: true,
                swipeToSlide: true,
                prevArrow: `.${galleryV2Semantics.mainWrapClass}` + 
                    `[${galleryV2Semantics.instanceIdAttribute}="` + 
                    el.attr(`${galleryV2Semantics.instanceIdAttribute}`) + 
                    `"] .${galleryV2Semantics.controlPrevClass}`,
                nextArrow: `.${galleryV2Semantics.mainWrapClass}` + 
                    `[${galleryV2Semantics.instanceIdAttribute}="` + 
                    el.attr(`${galleryV2Semantics.instanceIdAttribute}`) + 
                    `"] .${galleryV2Semantics.controlNextClass}`,
            }
        );
        el.show();
        try {
            // TODO[dependDetected]: slick plugin
            // the better solution: impl pluginProvider
            let slick = el.find(
                `.${galleryV2Semantics.sliderElementClass}`
            ).slick(pluginOptions);

            el.attr(`${galleryV2Semantics.isInitializedAttribute}`, true);
            window.widgets.galleryV2.pluginInstances[instanceId] = slick;
        } catch(e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
         el.on('click', `.${galleryV2Semantics.overlayElementClass}`, function (event) {
            event.preventDefault();
            const index = $(this).closest(`.${galleryV2Semantics.slideElement}`).index();
            console.log('curIndex', index)
            let items = [];
            // собираем галлерею
            el.find(`.${galleryV2Semantics.slideElement}`).filter(function() {
                  return !$(this).closest('.slick-cloned').length;
            }).each(function () {
                const src = $(this).find('img').attr('data-src');
                const title = $(this).find('img').attr('alt') || '';

                if (src) {
                    items.push({
                        src: src,
                        title: title,
                        type: 'image'
                    });
                }
            });
             console.log(items);
            if (!items || !items.length) {
                console.warn('No popup items found');
                return;
            }
            $.magnificPopup.open({
                items: items,
                gallery: {
                    enabled: true,
                    tCounter: '%curr% из %total%',
                },
                type: 'image',
                mainClass: galleryV2Semantics.popupMainClass,
                image: {
                    verticalFit: true,
                    titleSrc: 'title'
                }
            }, index);
        });
    }

    reInit(instanceId) {
       // console.log(this.pluginInstances[instanceId].slick());
        window.widgets.galleryV2.pluginInstances[instanceId].slick('unslick').slick('init');
    }
}